import {
  Box,
  IconButton,
  MenuItem,
  Select,
  Tooltip,
  Typography,
} from "@mui/material";
import { SelectFieldStyled } from "./select-field.styles";
import { SelectFieldProps } from "../common-types";
import OverflowText from "../../overflow-text/overflow-text";
import { useRef, useEffect, useState } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const SelectField = (props: SelectFieldProps) => {
  const {
    name,
    label,
    value,
    error,
    disabled,
    options,
    multiple,
    className,
    placeholder,
    onChange,
    InputProps,
    defaultValue,
  } = props;

  const selectRef = useRef<HTMLDivElement>(null);
  const [selectWidth, setSelectWidth] = useState<number | null>(null);

  // Update width measurement when component mounts or window resizes
  useEffect(() => {
    const updateWidth = () => {
      if (selectRef.current) {
        setSelectWidth(selectRef.current.offsetWidth);
      }
    };

    // Initial measurement
    updateWidth();

    // Add resize listener
    window.addEventListener("resize", updateWidth);

    // Cleanup
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  return (
    <SelectFieldStyled className={`${className || ""} field-wrapper`}>
      {label && <Typography className="field-label">{label}</Typography>}
      <div ref={selectRef} style={{ width: "100%" }}>
        <Select
          displayEmpty
          sx={{ width: "100%" }}
          value={value}
          id={name}
          onChange={onChange}
          error={!!error}
          multiple={multiple}
          disabled={disabled}
          defaultValue={defaultValue}
          MenuProps={{
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "left",
            },
            PaperProps: {
              style: {
                maxWidth: selectWidth ? `${selectWidth}px` : "100%",
                width: selectWidth ? `${selectWidth}px` : "100%",
                marginTop: "8px",
                marginLeft: "0px",
              },
            },
            disableAutoFocus: true,
            disableEnforceFocus: true,
            anchorReference: "anchorEl",
          }}
        >
          {Boolean(placeholder) && (
            <MenuItem disabled value="">
              {placeholder}
            </MenuItem>
          )}
          {options?.map(({ label, value, description }, index) => {
            return (
              // <MenuItem
              //   className="menu-item"
              //   value={value}
              //   key={index}
              //   sx={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
              // >
              //   {/* <OverflowText> */}
              //     {label}
              //   {/* </OverflowText> */}
              // </MenuItem>
              <MenuItem
                className="menu-item"
                value={value}
                key={index}
                sx={{
                  whiteSpace: "normal",
                  wordWrap: "break-word",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", flex: 1 }}>
                  <span>{label}</span>
                  {description && (
                    <Tooltip title={description} arrow placement="right">
                      <IconButton
                        size="small"
                        sx={{ ml: 1 }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <InfoOutlinedIcon fontSize="medium" />
                      </IconButton>
                    </Tooltip>
                  )}
                </Box>
              </MenuItem>
            );
          })}
        </Select>
      </div>
    </SelectFieldStyled>
  );
};

export default SelectField;
